import {analytics, history, QT} from './globals/config';
import switchStep from './components/switchStep';
import {setIssue} from './components/setters';
import serviceDescription from './modules/serviceDescription';
import {loadMarques, vehicleSelectorModule} from './modules/vehicleSelector';
import garageLocator from './modules/garageLocator';
import {replacementModule} from './modules/replacements';
import {userInfo} from './modules/userInfo';
import {summaryModule} from './modules/summary';
import {confirmModule} from './modules/confirmation';
import {dateSelector} from './modules/dateSelector';
import qtAnalytics, {handleImpressions} from './components/qtAnalytics';


const $ = jQuery;
const $quoteToolContainer = $('#quote-tool');

export default function () {
    handleImpressions('qt-start');
    loadMarques();

    // Modules
    serviceDescription();
    vehicleSelectorModule();
    garageLocator();
    replacementModule();
    userInfo();
    summaryModule();
    confirmModule();
    dateSelector();

    // When Quote Tool is loaded track event
    let startingStep = document.querySelector('.c-qt-starting-step');

    if(startingStep) {
        if(startingStep.classList.contains('active')) {
            const eventData = {
				event: 'tool-start',
				info: {
					toolType: 'request-form',
					toolName: 'wonderservice-quote',
					toolStep: 'online-diagnosis',
					leadID: '',
					requestType: 'quote',
					toolStepOption: '',
					toolStepNumber: 1,
				},
			};

			analytics.trackEvent(eventData);
        }
    }

    /**
     * Load other service ID and remove property from Quote Tool container.
     */
    QT.otherService = $quoteToolContainer.attr('data-other-service');
    $quoteToolContainer.removeAttr('data-other-service');

    /**
     * Check for prefooter on page with quote tool and remove margin.
     */
    if ($('.prefooter').length) {
        $('.prefooter .prefooter__container').attr('style', 'margin-top: 0px !important;');
    }

    /**
     * Global application event listeners.
     */
    $quoteToolContainer.on('click', '.js-qt-return-to-homepage', function () {
        const eventData = {
            event: 'button-click',
            info: {
                buttonType: 'link',
                buttonCategory: 'inbound-link',
                buttonName: 'to-homepage',
                buttonText: $(this).text(),
                buttonTarget: window.location.origin,
                buttonPosition: 'quote-tool',
            },
        };

        analytics.trackEvent(eventData);
        window.location.href = window.location.origin;
    });

    $quoteToolContainer.on('click', '.js-qt-return-to-diagnosis', function () {
        const eventData = {
            event: 'button-click',
            info: {
                buttonType: 'button-cta',
                buttonCategory: 'inbound-link',
                buttonName: 'to-make-appointment',
                buttonText: $(this).text(),
                buttonTarget: window.location.href,
                buttonPosition: 'quote-tool',
            },
        };

        analytics.trackEvent(eventData);

        switchStep('reports');
        history.push('reports');
    });

    $quoteToolContainer.on('click', '.js-qt-return', function () {
        if (history.length > 1) {
            history.pop();
            switchStep(history[history.length - 1], QT.wpServiceId);
        }


        if (history.length <= 1) {
            $('.js-qt-return').hide();
        }
    });

    $quoteToolContainer.on('click', '.js-qt-next-step', function (event) {
        setIssue(this);

        let nextStep = '';
        let serviceId = $(this).data('service-id');
        let isParticular = $(this).data('particular');
        let services = [];

        if (serviceId) {
           services.push({
				serviceId: serviceId,
			});
			QT.wpServiceId = services;

			nextStep = 'additional-info';

			if (isParticular) {
				QT.particularServiceSelected = true;
			} else {
				QT.particularServiceSelected = false;
			}
		} else {
			nextStep = $(this).data('next-step');

			if (nextStep === 'reports') {
				qtAnalytics('online-diagnosis-submit');
			}
		}

        switchStep(nextStep, this);
        history.push(nextStep);

        $('.js-qt-return').show();
    });

    /**
     * Additional info submit.
     */
    $quoteToolContainer.on('click', '.js-qt-additional-info--submit', function () {
        if (history[history.length - 2] === 'step - 1 - 0 - 1') {
            qtAnalytics('extra-info-submit', null, 2.4);
        } else {
            qtAnalytics('extra-info-submit');
        }

        switchStep('diagnosis');
        history.push('diagnosis');

        // if (QT.wpServiceId !== QT.otherService) {
        //     switchStep('diagnosis');
        //     history.push('diagnosis');
        // } else {
        //     switchStep('vehicle');
        //     history.push('vehicle');
        // }
    });

    /**
     * Icon select step event listeners.
     */
    $quoteToolContainer.on('click', '.js-qt-icon-select-item', function () {
		$(this).toggleClass('active');
		// Check if at least one icon is selected and if so find js-qt-confirm-icon-select and remove .c-button--disabled clas
        let $confirmButton = $('.js-qt-confirm-icon-select');
        let $activeIcons = $('.js-qt-icon-select-item.active');

        if ($activeIcons.length > 0) {
            $confirmButton.removeClass('c-button--disabled');
        } else {
            $confirmButton.addClass('c-button--disabled');
        }
	});

    $quoteToolContainer.on('click', '.js-qt-confirm-icon-select', function () {
        let services = [];

        $('.js-qt-icon-select-item.active').each(function() {
            let $this = $(this);
            let serviceId = $this.attr('data-service-id');
            let serviceName = $this.attr('data-service-name');
            let serviceEngName = $this.attr('data-service-eng-name');
            let iconType = $this.attr('data-type'); // Assuming iconType is common for all

            services.push({
                serviceId: serviceId,
                serviceName: serviceName,
                serviceEngName: serviceEngName,
                iconType: iconType
            });
        });
        QT.wpServiceId = services;

        // Handle next step based on user selection
        let nextStep = '';

        let hasRedIcon = false;
        hasRedIcon = services.some(service => service.iconType === 'red');

        console.log('hasRedIcon', hasRedIcon);
        if (hasRedIcon) {
            nextStep = $('.garage-locator').attr('data-step-name');
            let garageAlert = document.querySelector('.garage-locator__alert');
            if(garageAlert) {
                garageAlert.classList.add('active');
            }
            handleImpressions('uncertainty-dealer');
        } else {
            nextStep = 'additional-info';
            let garageAlert = document.querySelector('.garage-locator__alert');
			if (garageAlert) {
				garageAlert.classList.remove('active');
			}
        }

        if(!document.querySelector('#quote-tool').classList.contains('is-in-ai-flow')) {
            if (services.length > 0) {
                let firstService = services[0];
                let serviceEngName = firstService.serviceEngName;
                let serviceName = firstService.serviceName;
                qtAnalytics('symbol-submit', serviceEngName ? serviceEngName : serviceName);
            }
        }

        if (history[history.length - 1] === 'step - 1 - 0 - 0') {
            qtAnalytics('dealer-start');
        }


        switchStep(nextStep);
        history.push(nextStep);

        if(document.querySelector('.garage-locator--block.active')) {
            qtAnalytics('dealer-start');
        }

        $('.js-qt-return').show();
    });

    /**
     * Remove active state after select value changes.
     */
    $('#quote-tool .js-qt-marque-select select').change(function () {
        $(this).trigger('blur');
    });
}
